module.exports = __webpack_public_path__ + "static/img/2.8f6391a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/2.jpg
// module id = QUor
// module chunks = 1